import { combineReducers } from '@reduxjs/toolkit';
import { connectRouter } from 'connected-react-router';
import userReducer from './userReducer';
import monitorReducer from './monitorReducer';
import appReducer from './appReducer';
import productReducer from './productReducer';

export default (history: any) =>
  combineReducers({
    router: connectRouter(history),
    monitor: monitorReducer,
    user: userReducer,
    app: appReducer,
    product: productReducer,
  });
